import React, { memo } from 'react'
import { number } from 'prop-types'
import { useTheme } from 'emotion-theming'

export const BannerRibbon = memo(({ height = 47, width = 40 }) => {
	const {
		bestPicks: { bannerRibbonColor1, bannerRibbonColor2, bannerRibbonColor3, bannerRibbonColor4 },
	} = useTheme()

	return (
		<svg
			width={width}
			height={height}
			viewBox="0 0 40 47"
			version="1.1"
			xmlns="http://www.w3.org/2000/svg"
			xmlnsXlink="http://www.w3.org/1999/xlink"
		>
			<defs>
				<rect id="path-1" x="0" y="0" width="22" height="4"></rect>
				<linearGradient x1="50%" y1="0.814046922%" x2="50%" y2="98.340521%" id="linearGradient-3">
					<stop stopColor={bannerRibbonColor3} offset="0%"></stop>
					<stop stopColor={bannerRibbonColor4} offset="100%"></stop>
				</linearGradient>
				<linearGradient x1="50%" y1="0%" x2="50%" y2="100%" id="linearGradient-4">
					<stop stopColor={bannerRibbonColor1} offset="0%"></stop>
					<stop stopColor={bannerRibbonColor2} offset="100%"></stop>
				</linearGradient>
			</defs>
			<g id="Desktop---Latest" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
				<g id="Pg---V6a---SemiFinal---MBP-CatPg-FINAL" transform="translate(-365.000000, -3782.000000)">
					<g id="ic_ribbon-featured-sponsor" transform="translate(365.000000, 3782.000000)">
						<g id="Back-loop">
							<mask id="mask-2" fill="white">
								<use xlinkHref="#path-1"></use>
							</mask>
							<use id="MASK" fillOpacity="0" fill="#7BFF00" xlinkHref="#path-1"></use>
							<path
								d="M4.53243466,0.00276957354 C5.25546724,0.00276957354 6.27573558,0.00276957354 7.5932397,0.00276957354 L12.8408065,8.92561964 C15.6136022,16.4896956 17,20.263101 17,20.245836 C17,17.7194604 17,22.7769692 17,35.4183626 L17,44.8452902 L3.01118082,54 C3.00372694,22.7171701 3,5.3002804 3,1.74933086 C3,-0.146640475 4.53243466,0.00276957354 4.53243466,0.00276957354 Z"
								id="Path-3"
								fill="url(#linearGradient-3)"
								mask="url(#mask-2)"
							></path>
						</g>
						<path
							d="M7.39462148,1.75394447 C7.39462148,0.823720228 6.92974765,0.23907207 6,0 C8.69503529,0 10.1247292,0 10.2890819,0 C12.0305698,0 21.1578906,0 37.6710444,0 C39.2236815,0.0941239029 40,1.07329057 40,2.9375 C40,4.80170943 40,19.4892094 40,47 L23.6973021,37.9062009 L7.39462148,47 C7.39462148,17.7661872 7.39462148,2.68416872 7.39462148,1.75394447 Z"
							id="Path-3"
							fill="url(#linearGradient-4)"
						></path>
					</g>
				</g>
			</g>
		</svg>
	)
})

BannerRibbon.propTypes = {
	height: number,
	width: number,
}
